import {
  Box,
  Button,
  CircularProgress,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  useMediaQuery,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { reducerPaths } from '../../../app/reducerPaths';
import logoWithoutText from '../../../components/assets/logo-without-text.svg';
import CurrencyTag from '../../../components/ui/Currency/CurrencyTag';
import theme from '../../../theme';
import { localAuction } from '../../../utils/constants/auction';
import { formatAuctionDateTime } from '../../../utils/methods/dateTime';
import { getRGBAFromColor } from '../../../utils/methods/getCssVariables';
import { getCommaFormattedPrice } from '../../../utils/methods/stringMethods';
import { currencies, currencyToCurrencySymbolMap } from '../../../utils/constants/currencies';
import { walletTypes, walletValuesToCurrenciesMapping } from '../../../utils/constants/walletTypes';
import { useLazyGetVehicleFrozenWalletTypeForUserQuery } from '../../../toolkit/vehicle/vehicleApi';
import { USER_ROLES } from "../../../utils/constants/userRoles";
import React from 'react';

const BidHistory = ({ selectedCar, bids = [], isLoading, showTitle = true }) => {
  const { t } = useTranslation('bidHistory');

  const isMobile = useMediaQuery('(max-width:1700px)');

  const auth = useSelector((store) => store[reducerPaths.auth]);
  const currency = useSelector((store) => store[reducerPaths.currencySlice]);

  const [getVehicleFrozenWalletTypeForUserApiHandler, getVehicleFrozenWalletTypeForUserApiData] = useLazyGetVehicleFrozenWalletTypeForUserQuery();

  React.useEffect(() => {
    if (!selectedCar?.Vehicle_Id) {
      return;
    }

    (async () => {
      await getVehicleFrozenWalletTypeForUserApiHandler({
        params: {
          vehicle_id: selectedCar?.Vehicle_Id
        }
      })
    })();
  }, [selectedCar?.Vehicle_Id]);

  console.log(bids, "BidHistorybids");

  return (
    <Box>
      {showTitle ? (
        <Typography variant="h5" component="h2" sx={{ mb: 2, fontWeight: 'bold', color: theme.palette.primary.main }}>
          {t('Bid History')}
        </Typography>
      ) : null}
      <TableContainer
        component={Paper}
        variant="outlined"
        sx={{
          borderRadius: '1rem',
          height: '330px',
          overflow: 'auto', // Ensure scrolling is enabled for sticky to work
          // remove scrollbar
          '&::-webkit-scrollbar': {
            display: 'none',
          },
        }}
      >
        {typeof isLoading === 'boolean' && isLoading ? (
          <Box
            sx={{
              height: '100%',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <CircularProgress />
          </Box>
        ) : bids?.length === 0 ? (
          <Box
            sx={{
              height: '100%',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <Typography
              sx={{
                fontSize: '1.25rem',
                fontWeight: 'bold',
                color: theme.palette.text.primary,
              }}
            >
              {t('No bids yet')}
            </Typography>
          </Box>
        ) : (
          <Table
            // stickyHeader
            sx={{
              padding: '0 !important',
            }}
          >
            <TableHead>
              <TableRow
                sx={{
                  background: 'black',
                  '& .MuiTableCell-root': {
                    background: `transparent !important`,
                  },
                }}
              >
                <TableCell sx={{ color: 'white', fontWeight: 'bold', textWrap: 'nowrap' }}>{t('Bid Amount')}</TableCell>
                <TableCell sx={{ color: 'white', fontWeight: 'bold', textAlign: 'right', textWrap: 'nowrap' }}>
                  {t('Date-Time')}
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {bids?.map((bid, index) => {
                const dateTime = formatAuctionDateTime(bid?.dateTime);
                return (
                  <TableRow
                    key={index}
                    sx={{
                      backgroundColor:
                        index % 2 === 0
                          ? theme.palette.background.paper
                          : getRGBAFromColor({
                              color: theme.palette.text.primary,
                              alpha: '0.1',
                            }),
                      '& td': {
                        padding: '0.5rem 0.75rem !important',
                      },
                    }}
                  >
                    <TableCell>
                      <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        <Box
                          component="img"
                          src={bid?.bidderIcon || logoWithoutText}
                          alt="Bidder"
                          sx={{ width: 30, mr: 1 }}
                        />
                        {/* ${currencyConversionFormat(bid.amount)} */}
                        <Box
                          sx={{
                            display: 'flex',
                            flexDirection: 'column',
                          }}
                        >
                          <Typography
                            sx={{
                              fontWeight: '600',
                            }}
                          >
                            ${getCommaFormattedPrice(bid?.amount)}{' '}
                            {selectedCar?.auction_type === localAuction || bid?.dealer_type === "bot" ? (
                              ''
                            ) : (
                              (bid?.active_wallet_type && ((auth?.user_role === USER_ROLES.buyer && parseInt(bid?.Dealer_Id) === auth?.user_id) || auth?.user_role !== USER_ROLES.buyer)) ? (
                                <Button
                                  sx={{
                                    marginLeft: "0.35rem",
                                    padding: "0 !important",
                                    border: `1px solid ${theme.palette.primary.main}`
                                  }}
                                >
                                  {walletValuesToCurrenciesMapping[bid?.active_wallet_type] === currencies.NGN ? "Fiat" : "Crypto"}
                                </Button>
                                // <CurrencyTag
                                //   // showCurrencyLabel={true}
                                //   outputCurrency={walletValuesToCurrenciesMapping[bid?.active_wallet_type]}
                                //   amount={bid?.amount}
                                //   conversionRates={currency?.conversionRates}
                                //   component={'span'}
                                //   sx={{
                                //     fontSize: '1rem',
                                //   }}
                                //   addParenthesis={true}
                                // />
                              ) : null
                            )}
                          </Typography>

                          <Typography>
                            {selectedCar &&
                            'auction_type' in (selectedCar || {}) &&
                            selectedCar?.auction_type === localAuction
                              ? t('Dealer ID')
                              : t('Buyer ID')}
                            : {bid?.dealerId || bid?.Dealer_Id} {auth?.user_id === parseInt(bid?.dealerId || bid?.Dealer_Id) ? t('(You)') : ''}
                          </Typography>
                        </Box>
                      </Box>
                    </TableCell>
                    <TableCell
                      sx={{
                        textAlign: 'right',
                      }}
                    >
                      <Box
                        sx={{
                          display: 'flex',
                          flexDirection: 'column',
                          alignItems: 'flex-end',
                        }}
                      >
                        <Typography>
                          {dateTime?.split?.(' - ')?.[0]}
                          {/* {bid.dateTime?.split?.(" ")?.[0]} */}
                          {/* {convertToUTCFormat(bid?.dateTime)} */}
                        </Typography>
                        <Typography>
                          {dateTime?.split?.(' - ')?.[1]}
                          {/* {bid.dateTime?.split?.(" ")?.[1]} */}
                        </Typography>
                      </Box>
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        )}
      </TableContainer>
    </Box>
  );
};

export { BidHistory };
